import React from 'react';
import { CloseCircleRed } from '../../../common/icons/CloseCircleRed';
import { Calendar } from '../../../common/icons/Calendar';
import DatePicker from 'react-datepicker';
import { IDatePicker } from '../../../@types/datePicker';
import {
  CalendarIconContainer,
  InputContainer,
  MyAuditDatePickerContainer,
} from '../../sharedStyledComponents/Datepicker.styled';

export function DatePickerDateTime ({ startDate, setStartDate }: IDatePicker) {

  const handleDateChange = (selectedDate: Date | null) => {
    if (selectedDate && !startDate) {
      const currentDate = new Date();
      selectedDate.setHours(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
    }
    setStartDate(selectedDate || undefined);
  };

  return (
    <MyAuditDatePickerContainer>
      <InputContainer>
        <DatePicker
          className={`myaudit-filter-date-picker`}
          selected={startDate && new Date(startDate)}
          onChange={handleDateChange}
          timeInputLabel="Time:"
          dateFormat="MM/dd/yyyy h:mm aa"
          onFocus={(event) => event.target.blur()}
          placeholderText="Date"
          showTimeInput={true}
        />
        <CalendarIconContainer>
          {startDate ? (
            <CloseCircleRed onClick={() => setStartDate(undefined)} />
          ) : (
            <Calendar />
          )}
        </CalendarIconContainer>
      </InputContainer>
    </MyAuditDatePickerContainer>
  );
}
